import { ErrorDeBase } from './errores';
import { supabase } from './supabase';

export type Esquema = 'gen' | 'sec' | 'led' | 'stk' | 'doc' | 'aco' | 'trn' | 'adm' | 'rpt';

interface RespuestaPostgrest {
  data: unknown;
  error: { message: string; code?: string } | null;
}

/**
 * Desenvuelve la respuesta de PostgREST: si hay error lo lanza como `ErrorDeBase`
 * (asi TanStack Query lo ve como fallo), si no devuelve los datos.
 * El cliente de supabase no tiene tipos generados de la base, asi que infiere las filas
 * (sobre todo los embeds) de forma poco fiable: `T` lo declara quien llama, y esta es
 * la unica frontera donde se lo asume.
 */
export async function esperar<T>(consulta: PromiseLike<RespuestaPostgrest>): Promise<T> {
  const { data, error } = await consulta;
  if (error) throw new ErrorDeBase(error.message, error.code);
  return data as T;
}

/**
 * Llama a una funcion de la base: `supabase.schema(x).rpc(fn, args)`.
 * Los parametros van por nombre, tal cual figuran en docs/FRONTEND_funciones_y_pantallas.md.
 */
export function llamarRpc<T>(
  esquema: Esquema,
  funcion: string,
  args: Record<string, unknown> = {},
): Promise<T> {
  return esperar<T>(supabase.schema(esquema).rpc(funcion, args));
}
